import { useCoviSummaryMemory } from "@/hooks/useCoviSummaryMemory"

import { useCovi } from "../contexts/CoviContext"
import { SummaryMemoryMenu } from "./CoviPanelMenus"

/**
 * The summary-memory editor, surfaced in the app-shell top bar on the Sofia
 * Home landing. The full-page chat surface carries this in the CoviPanel
 * header; the landing has no panel header, so it injects the same control into
 * the shell header (see HomeRoute's useSetHeaderActions) — the memory a user
 * picks here carries into the thread they start.
 */
export function SofiaHomeHeaderControls() {
  const { orgSlug } = useCovi()
  const {
    canEditSummaryMemory,
    clearSummaryMemory,
    setSummaryPreferencesText,
    summaryPreferencesText,
  } = useCoviSummaryMemory(orgSlug)

  return (
    <div className="flex items-center gap-0.5">
      <SummaryMemoryMenu
        canEdit={canEditSummaryMemory}
        preferencesText={summaryPreferencesText}
        onChange={setSummaryPreferencesText}
        onClear={clearSummaryMemory}
      />
    </div>
  )
}
